import React from "react";
import "./projectPage.css";
import { useNavigate } from "react-router-dom";

const projects = [
  {
    id: "Snapper",
    title: "Snapper",
    category: "UX Design",
    description: "Scuba diving social app with marine life reporting",
    image: "/assets/projects/snapper.png",
    featured: true,
  },
  {
    id: "Armoire",
    title: "Armoire",
    category: "UX Design",
    description: "Pinterest-inspired closet organization app",
    image: "/assets/projects/amoire.png",
    featured: true,
  },
  {
    id: "Collide",
    title: "Collide",
    category: "Development",
    description: "Scout's annual design conference website",
    image: "/assets/projects/collide2.png",
    featured: true,
  },
  {
    id: "JuzDelights",
    title: "Juz Delights",
    category: "UX Design",
    description: "E-commerce for healthy meals",
    image: "/assets/projects/juz-delights2.png",
  },
  {
    id: "TsengLab",
    title: "Tseng Lab",
    category: "Data",
    description: "Gene data visualization dashboard",
    image: "/assets/projects/tseng.png",
  },
  {
    id: "StudentHub",
    title: "Student Hub",
    category: "UX Design",
    description: "Northeastern mobile app redesign",
    image: "/assets/projects/StudentHubRedesign.png",
  },
  {
    id: "NeighborhoodNav",
    title: "Neighborhood Nav",
    category: "UX Design",
    description: "Travel destination finder",
    image: "/assets/projects/Neighborhood_nav2.png",
  },
];

function ProjectSection() {
  const navigate = useNavigate();
  
  const featuredProjects = projects.filter(p => p.featured);
  const otherProjects = projects.filter(p => !p.featured);

  const handleClick = (id) => {
    navigate(`/project/${id}`);
  };

  return (
    <section id="projects" className="projects-section">
      <div className="projects-container">
        <h1 className="section-title">Projects</h1>
        
        <div className="projects-scroll-wrapper">
          {/* Featured projects - larger */}
          <div className="featured-grid">
            {featuredProjects.map((project) => (
              <article 
                key={project.id} 
                className="project-card featured"
                onClick={() => handleClick(project.id)}
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleClick(project.id)}
              >
                {/* Image wrapper clips the zoom animation */}
                <div className="project-image-wrapper">
                  <div className="project-image" style={{ backgroundImage: `url(${project.image})` }} />
                </div>
                <div className="project-info">
                  <span className="project-category">{project.category}</span>
                  <h3 className="project-name">{project.title}</h3>
                  <p className="project-desc">{project.description}</p>
                </div>
              </article>
            ))}
          </div>

          {/* Other projects - smaller grid */}
          <div className="other-grid">
            {otherProjects.map((project) => (
              <article 
                key={project.id} 
                className="project-card small"
                onClick={() => handleClick(project.id)}
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleClick(project.id)}
              >
                {/* Image wrapper clips the zoom animation */}
                <div className="project-image-wrapper">
                  <div className="project-image" style={{ backgroundImage: `url(${project.image})` }} />
                </div>
                <div className="project-info">
                  <span className="project-category">{project.category}</span>
                  <h3 className="project-name">{project.title}</h3>
                  <p className="project-desc">{project.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProjectSection;
